export const PhoneFABSVG = ({
  width = "54",
  height = "54",
  isOpen = false,
}: {
  width?: string;
  height?: string;
  isOpen?: boolean;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 65 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter
        id="phone-fab-shadow"
        x="-1.5"
        y="0.661"
        width="66"
        height="66"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0.73 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
    <g filter="url(#phone-fab-shadow)">
      <circle cx="31.5" cy="29.661" r="26.5" fill="#272323" />
    </g>
    {isOpen ? (
      <>
        <line x1="22" y1="20" x2="42" y2="40" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
        <line x1="42" y1="20" x2="22" y2="40" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
      </>
    ) : (
      <path
        d="M40.8932 41.1875C38.3252 41.1875 35.788 40.6279 33.2817 39.5086C30.7753 38.3894 28.4949 36.8022 26.4405 34.747C24.3861 32.6917 22.7993 30.4114 21.6801 27.9058C20.5609 25.4003 20.0008 22.8631 20 20.2943C20 19.9245 20.1233 19.6163 20.3698 19.3698C20.6163 19.1233 20.9245 19 21.2943 19H26.2865C26.5741 19 26.8309 19.0978 27.0569 19.2934C27.2828 19.4889 27.4164 19.7199 27.4575 19.9861L28.2587 24.3003C28.2998 24.6291 28.2895 24.9064 28.2279 25.1324C28.1662 25.3584 28.0532 25.5535 27.8889 25.7179L24.8997 28.7378C25.3106 29.498 25.7983 30.2322 26.3629 30.9406C26.9274 31.6489 27.5491 32.3322 28.2279 32.9905C28.8647 33.6273 29.5324 34.2182 30.2309 34.763C30.9294 35.3078 31.669 35.8058 32.4497 36.2569L35.3464 33.3602C35.5312 33.1753 35.7728 33.0369 36.0711 32.9448C36.3694 32.8528 36.662 32.8269 36.9488 32.8672L41.2014 33.73C41.489 33.8122 41.7253 33.9614 41.9102 34.1775C42.0951 34.3936 42.1875 34.6348 42.1875 34.901V39.8932C42.1875 40.263 42.0642 40.5712 41.8177 40.8177C41.5712 41.0642 41.263 41.1875 40.8932 41.1875Z"
        fill="white"
      />
    )}
  </svg>
);
